import type { DepartmentGroupTypeListResponseRow } from '@risksmart-app/drizzle/src/types';
import type { GetDepartmentTypeGroupsQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetDepartmentTypeGroupsDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type UseGetDepartmentTypeGroupsArgs = Record<string, never>;

export const useGetDepartmentTypeGroups = createQueryHook<
  UseGetDepartmentTypeGroupsArgs,
  DepartmentGroupTypeListResponseRow[],
  GetDepartmentTypeGroupsQuery
>({
  trpcQueryOptions: (trpc) =>
    trpc.frontend.department.departmentTypeGroups.queryOptions(),
  mapTrpcDataToGraphQL: (data) => ({ department_type_group: data }),
  graphqlDocument: GetDepartmentTypeGroupsDocument,
});
